import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const faqs = [{
  question: "What is included in an IT Masters AMC?",
  answer: "Our Annual Maintenance Contracts provide comprehensive 24/7 support, including proactive server monitoring, hardware maintenance, and unlimited remote assistance. We ensure your infrastructure remains resilient and downtime is virtually eliminated."
}, {
  question: "How do you handle high-stakes hospitality IT projects?",
  answer: "As specialists for brands like Marriott and Sheraton, we manage complex virtualization (VM) deployments and guest-facing network infrastructure. Our teams work with surgical precision to ensure zero disruption to hotel operations or guest experiences."
}, {
  question: "Can you help optimize our current IT procurement costs?",
  answer: "Yes. We leverage a decade of industry relationships to source enterprise-grade hardware and software at competitive rates. Our auditing process identifies redundancies, often reducing annual IT spend significantly without sacrificing performance."
}, {
  question: "What measures do you take for data protection and cloud backup?",
  answer: "We implement multi-tier, encrypted backup solutions tailored to your business scale. Partnering with gold-standard cybersecurity firms, we ensure your data is protected against threats and fully recoverable in any disaster scenario."
}, {
  question: "Do you provide on-site support for UAE-based businesses?",
  answer: "Absolutely. Based in the UAE, our engineers provide rapid on-site response for critical infrastructure issues. We bridge the gap between complex global technology standards and local business efficiency requirements."
}];
export default function DuvidasFrequentes() {
  return <section data-section-id="243447" id="common-inquiries" className="bg-background text-foreground py-24 px-4 md:px-8 relative overflow-hidden">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/10 rounded-lg blur-3xl pointer-events-none" />

      <div className="max-w-4xl mx-auto relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-default font-bold mb-4 tracking-tighter uppercase">
            Common Inquiries
          </h2>
          <p className="text-muted-foreground font-default text-lg max-w-2xl mx-auto">
            Technical insights into our infrastructure architecture, hospitality specializations, and strategic procurement.
          </p>
        </div>

        <Card className="bg-card/20 backdrop-blur-md border-border shadow-2xl rounded-md overflow-hidden">
          <CardContent className="p-6 md:p-10">
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-b border-border/30 data-[state=open]:border-primary transition-colors duration-300 py-2">
                  <AccordionTrigger className="font-default font-semibold text-lg md:text-xl text-left hover:no-underline hover:text-primary transition-colors">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="font-serif text-muted-foreground text-base leading-relaxed pt-2 pb-6">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </CardContent>
        </Card>

        <div className="mt-12 text-center">
          <p className="text-muted-foreground font-mono text-sm mb-6 uppercase tracking-widest">
            Require a technical audit or custom infrastructure design?
          </p>
          <Button asChild size="lg" className="font-default rounded-md px-8 bg-primary text-primary-foreground hover:shadow-[0_0_20px_rgba(0,149,255,0.4)] transition-all">
            <Link to="/ConnectPage">Consult an Architect</Link>
          </Button>
        </div>
      </div>
    </section>;
}